import {
  GridFilterInputMultipleValue,
  GridFilterInputValue,
  GridFilterOperator
} from "@mui/x-data-grid-pro";

import { Identifier } from "react-admin";

import { operator } from "types";

export const getGridIdentifierOperators = (): GridFilterOperator[] => [
  {
    label: "equals",
    value: operator.equals,
    getApplyFilterFn: (filterItem) => {
      return (params) => {
        return params === filterItem.value;
      };
    },
    InputComponent: GridFilterInputValue
  },
  {
    label: "is any of",
    value: operator.isAnyOf,
    getApplyFilterFn: (filterItem) => {
      return (params: Identifier) => {
        const id = typeof params === "string" ? params : params.toString();

        return filterItem.value.includes(id);
      };
    },
    InputComponent: GridFilterInputMultipleValue
  }
];
